import { render, staticRenderFns } from "./MemberScoreViewerComponent.vue?vue&type=template&id=4581c312&"
import script from "./MemberScoreViewerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberScoreViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberScoreViewerComponent.vue?vue&type=style&index=0&id=4581c312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports